import Fuse from 'fuse.js';
import type { PhotoLibraryItem } from '@/lib/photoLibraryTypes';

/**
 * Returns the best-matching library item for a given name string, or null if
 * no match exceeds the confidence threshold.
 */
export function findBestLibraryMatch(
  name: string,
  items: PhotoLibraryItem[],
): PhotoLibraryItem | null {
  if (!name || items.length === 0) return null;

  const fuse = new Fuse(items, {
    keys: ['name'],
    threshold: 0.4,
    includeScore: true,
  });

  const results = fuse.search(name);
  return results.length > 0 ? results[0].item : null;
}
